// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"ec09c99c","330":"d999fe44","674":"263526b4","699":"f4e88805","841":"ad317696"}[chunkId] + ".css";
};